const SURF_JOB_OPS = new Set([
    "slide.background",
    "slide.raster.text",
    "layer.image",
    "image.edit",
    "outline",
    "style.preview",
    "speaker.script",
]);
export function encodeSurfTargetParams(params, payload) {
    return JSON.stringify({
        openai: params,
        surfTarget: {
            op: payload.op,
            deckId: payload.deckId,
            slideId: payload.slideId,
            layerId: payload.layerId,
            editKind: payload.editKind,
            applyMeta: payload.applyMeta,
        },
    });
}
export function parseSurfTargetFromParamsJson(paramsJson) {
    if (!paramsJson?.trim())
        return null;
    try {
        const parsed = JSON.parse(paramsJson);
        const raw = parsed.surfTarget;
        if (!raw || typeof raw !== "object")
            return null;
        const op = String(raw.op ?? "");
        if (!SURF_JOB_OPS.has(op))
            return null;
        const deckId = String(raw.deckId ?? "").trim();
        if (!deckId)
            return null;
        const target = {
            op: op,
            deckId,
            slideId: typeof raw.slideId === "string" ? raw.slideId : undefined,
            layerId: typeof raw.layerId === "string" ? raw.layerId : undefined,
            editKind: raw.editKind === "layer" ||
                raw.editKind === "textRaster" ||
                raw.editKind === "background"
                ? raw.editKind
                : undefined,
            applyMeta: raw.applyMeta && typeof raw.applyMeta === "object"
                ? raw.applyMeta
                : undefined,
        };
        return target;
    }
    catch {
        return null;
    }
}
export function surfTargetToJobTarget(payload) {
    return {
        slideId: payload.slideId,
        layerId: payload.layerId,
        editKind: payload.editKind,
    };
}
export function encodeSurfBedrockTargetParams(bedrock, payload) {
    return JSON.stringify({
        bedrock,
        surfTarget: {
            op: payload.op,
            deckId: payload.deckId,
            slideId: payload.slideId,
            layerId: payload.layerId,
            editKind: payload.editKind,
            applyMeta: payload.applyMeta,
        },
    });
}
